<template>
  <div class="pulse-effect-container" :class="{active}" :style="`--pulse-effect-color:${color}`">
    <slot/>
  </div>
</template>
<style lang="scss">
  .pulse-effect-container.active {
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(var(--pulse-effect-color), 0.7);
    }

    70% {
      transform: scale(1);
      box-shadow: 0 0 0 10px rgba(var(--pulse-effect-color), 0);
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(var(--pulse-effect-color), 0);
    }
  }
</style>
<script>
  export default {
    props: {
      colorRgb: {
        type: Array,
        default: () => ([0, 0, 0])
      },
      active: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      color() {
        return this.colorRgb.join(', ')
      }
    }
  }
</script>